// import React from "react";
// import { MathJax, MathJaxContext } from "better-react-mathjax";

// export default function Expression() {
//   return (
//     <MathJaxContext>
//       <h2>Basic MathJax example with Latex</h2>
//       <MathJax>{"\\(\\frac{10}{4x} \\approx 2^{12}\\)"}</MathJax>
//     </MathJaxContext>
//   );
// }
// import "katex/dist/katex.min.css";

import React from "react";
import "katex/dist/katex.min.css";
import { BlockMath } from "react-katex";

const Expression = ({ expression = "int " }) => {
  // console.log("rendering ", expression);
  return (
    <>
      {expression === "" ? (
        <h1 className="text-2xl ">Say Something</h1>
      ) : (
        <div style={{ padding: 0 }}>
          <div>
            {/* <h1>Processing: {expression}</h1> */}

            <BlockMath
              renderError={(error) => {
                return <b>Fail: {error.name}</b>;
              }}
              //   math={"\begin{equation*}2x^{2}=8end{equation*}"}
              // math={``}
              math={expression.replace("dtheta", "dθ")}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Expression;
